import { useEsitoListSorted, useInfoAggiuntivaData } from 'features/sport/hooks';

import { AntepostItemProps } from './types';
import React from 'react';
import { ScommesseEsitoSkeleton } from 'components/scommesseEsitoSkeleton';
import { ScommesseEsitoTipoCard } from 'components/scommesseEsitoTipoCard';
import { ScommesseLeafItem } from '../components/cells';
import { isTruthy } from 'utility/functions';

export const AntepostItem = ({ scommessaKey, infoAggiuntivaKey, gtagAction }: AntepostItemProps) => {
  const esitoList = useEsitoListSorted(infoAggiuntivaKey);
  const infoAggData = useInfoAggiuntivaData(infoAggiuntivaKey);

  return (
    <React.Fragment key={infoAggiuntivaKey}>
      {esitoList?.map((key) =>
        isTruthy(infoAggData?.isActive) ? (
          <ScommesseEsitoTipoCard
            key={key}
            scommessaKey={scommessaKey}
            infoAggiuntivaKey={infoAggiuntivaKey}
            keyEsito={key}
            gtagAction={gtagAction}
            type={ScommesseLeafItem.Quota}
          />
        ) : (
          <ScommesseEsitoSkeleton key={key} text="-" testId={key} />
        )
      )}
    </React.Fragment>
  );
};
